"use strict";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".boxes-slider").forEach((container) => {
        container.querySelectorAll(".boxes-slider-slider").forEach((sliderEl) => {
            new Swiper(sliderEl, {
                modules: [Navigation, Pagination],
                slidesPerView: "auto",
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: sliderEl.querySelector('.arrows-next'),
                    prevEl: sliderEl.querySelector('.arrows-prev'),
                }
            });
        });
    });
});